import React from 'react';
import { useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import { getRegion } from 'utils/Region';
import './index.scss'

const LiveSensitiveContent = () => {
  const translations = useSelector(
    state =>
      JSON.parse(state?.metadata?.translations || '{}')?.language[getRegion()],
  );
  const { Alerta_IconoAlerta } =
    useSelector(state => state.asset) || 'Alerta_IconoAlerta';
  return (
    <div className="live-verification-modal">
      <img alt={Alerta_IconoAlerta} src={Alerta_IconoAlerta} style={{width: "120px"}} />
      <h2 className="live-verification-modal__title">
        {getTranslation(
          'TvEnVivo_AlertaFalloDeValidacion_CanalBloqueado_TextoInformativo',
          translations,
        ) || 'TvEnVivo_AlertaFalloDeValidacion_CanalBloqueado_TextoInformativo'}
      </h2>
    </div>
  );
};

export default LiveSensitiveContent;
